import React, { useEffect, useState } from 'react'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import { useDispatch, useSelector } from 'react-redux'
import { clearDeletedDepartment, clearUpdatedDepartment, deleteDepartment, fetchDepartments } from '../../../../store/actions/departmentActions'
import { SET_SUCCESS } from '../../../../store/types'
import ModalDialog from '../../../../components/layouts/ModalDialog'
import Pagination from '../../../../components/elements/Pagination'
import Loader from '../../../../components/elements/Loader'
import EmptyState from '../../../../components/elements/EmptyState'
import PlusIcon from '../../../../components/elements/icons/PlusIcon'
import NewDepartment from '../../../../components/partials/departments/NewDepartment'
import DepartmentCard from '../../../../components/partials/departments/DepartmentCard'
import EditDepartment from '../../../../components/partials/departments/EditDepartment';

const Departments = () => {
  const dispatch = useDispatch()
  const departmentsSelector = useSelector(state => state.departments)
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  const [creatingDepartment, setCreatingDepartment] = useState(false);
  const [reload, setReload] = useState(0);
  useEffect(() => {
      dispatch(fetchDepartments())

      if(departmentsSelector.updatedDepartment && departmentsSelector.updatedDepartment !== null) {
          dispatch({
            type: SET_SUCCESS,
            payload: `Department updated successfully!`
          })
          dispatch(fetchDepartments())
          dispatch(clearUpdatedDepartment())
          closeDepartmentEdit(false)
      }

      if(departmentsSelector.deletedDepartment && departmentsSelector.deletedDepartment !== null) {
          dispatch({
            type: SET_SUCCESS,
            payload: `Department deleted successfully!`
          })
          dispatch(fetchDepartments())
          dispatch(clearDeletedDepartment())
          closeDepartmentEdit(false)
      }
      return () => {
          
      };
  }, [dispatch, departmentsSelector.createdDepartment, departmentsSelector.updatedDepartment, departmentsSelector.deletedDepartment, page, perPage]);

  const doDeleteDepartment = (deptId) => {
    if(window.confirm('Are you sure you want to delete this department?')) {
        dispatch(deleteDepartment(deptId))
    }
  }

  const [editingDepartment, setEditingDepartment] = useState(false);
  const [activeDepartment, setActiveDepartment] = useState(null);

  const openDepartmentEdit = (department) => {
      setActiveDepartment(department)
      setTimeout(() => {
          setEditingDepartment(true)
      }, 50);
  }

  const closeDepartmentEdit = () => {
      setActiveDepartment(null)
      setTimeout(() => {
          setEditingDepartment(false)
      }, 50);
  }

  return (
    <>
      <AdministrationLayout>
        <div className='w-full'>
          <div className='w-full flex justify-between'>
            <div className='w-9/12'>
              <h3 className='text-lg font-medium'>Vaatia College Departments</h3>
              <p className='text-sm'>All departments in vaatia college Makurdi. Click on a department to view details, subject and staff or create new departments anytime by clicking on the "Create Department" button</p>
            </div>
            
            <div>
              <button onClick={()=>{setCreatingDepartment(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                <PlusIcon className='w-5 h-5' /> Create Department
              </button>
            </div>
          </div>

          {departmentsSelector.loadingDepartments
          ? 
          <Loader /> 
          :
          <>
            {departmentsSelector?.departments?.departments && departmentsSelector?.departments?.departments?.length > 0 
              ? 
                <>
                  <div className='mt-8 mb-5 grid grid-cols-4 gap-8'>
                    {departmentsSelector?.departments?.departments?.map((department, departmentIndex) => (
                      <div key={departmentIndex}>
                        <DepartmentCard 
                          department={department} 
                          deleteDepartment={()=>{doDeleteDepartment(department._id)}} 
                          openDepartment={()=>{openDepartmentEdit(department)}}
                        />
                        {/* <AcademicSessionCard session={session} openSession={()=>{openSession(session)}} /> */}
                      </div>
                    ))}
                  </div> 
                  <Pagination 
                    pagination={{
                      perPage, 
                      page,
                      totalItems: departmentsSelector.departments.total,
                    }} 
                    changePage={setPage} 
                    updatePerPage={setPerPage}
                  />
              </>
              : 
              <div className='h-[300px] w-full flex items-center justify-center'>
                <EmptyState emptyStateText='No departments have been created yet. Click on "Create Department" above to create a new one'></EmptyState>
              </div>
            }
          </>}

        </div>
      </AdministrationLayout>

      <ModalDialog
        shown={creatingDepartment} 
        closeFunction={()=>{setCreatingDepartment(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Create Department`}
        dialogTitle='Create a new department'
        maxWidthClass='max-w-md'
        hideActions={true}
      >
          <NewDepartment 
            reload={()=>setReload(reload+1)}
            closeFunction={()=>{setCreatingDepartment(false)}} 
            // session={activeSession}
          />

      </ModalDialog>

      {activeDepartment && <ModalDialog
        shown={editingDepartment} 
        closeFunction={()=>{closeDepartmentEdit(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={`Edit Department`}
        dialogTitle='Edit this department'
        maxWidthClass='max-w-md'
        hideActions={true}
      >
        <EditDepartment department={activeDepartment} closeFunction={()=>{closeDepartmentEdit()}} />
      </ModalDialog>}
    </>
  )
}

export default Departments